// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6hZ6m","icon":"styles_icon__MXk1-","titleWrap":"styles_titleWrap__Q8d4O","body":"styles_body__bcwTQ","bodyItem":"styles_bodyItem__lEu+e"};